import React, { useState, useEffect, useMemo } from 'react';
import Constant from '@/common/constant/Constant';
import Utils, { isDisableApproveRejectAnonymousQaTicket } from '@/common/utils/utils';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import {
    getDetailTicketInList,
    getTitle,
    onClickApproveAnonymousQaTicket,
    onClickRejectAnonymousQaTicket,
    onSubmitApproveAnonymousQaFromLiveChat
} from './handler/TicketListHandler';
import { generateDetatilTicketTitle, isDisableApproveRejectAnonymousQaFromLiveChat } from './handler/TicketHandler';
import { Button, Typography } from '@material-ui/core';
import DetailTicketListThumbnail from './DetailTicketListThumbnail';
import DetailTicketListLastMessage from './DetailTicketListLastMessage';
import DetailTicketListAssignee from './DetailTicketListAssignee';
import DetailTicketListStatus from './DetailTicketListStatus';
import {
    closePanelTabSelector,
    setPanelSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { checkDetailTicket } from '@/service/ticketService';
import { I18n } from 'aws-amplify';
import DetailTicketListSkeleton from './DetailTicketListSkeleton';
import { getTicketStorageData, isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff } from './handler/DetailTicketListHandler';
import SDeskTooltip from '../common/SDeskTooltip';
import { handleDeleteCompleteTicketLiveChat, renderUserName, isDisplayIconChat } from '../chatThread/handler/DetailTicketHandler';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { signOut } from '@/service/authenService';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import Bookmark from '../ticketKnowledge/elements/Bookmark/Bookmark';
import TaggedBookmarkListName from '../ticketKnowledge/elements/Bookmark/TaggedBookmarkListName';

let MAX_LENGTH_DISPLAY_TEXT = 50;

export default function DetailTicketList(props) {
    const {
        API,
        ticket,
        ticketListType,
        isHelpdeskListTicket,
        isCustomerListTicket,
        selectedTicket,
        setSelectedTicket,
        setConfirmForceEditTicket,
        setIsOpenModalReloadPage,
        setIsConfirmAcceptTicket,
        setIsConfirmRejectTicket,
        setIsLoading,
        setTriggerSearch,
        projectUserList,
        panelId,
        ticketList,
        setTicketList,
        panelType,
        tabId,
        componentName,
        history,
        triggerSearch,
        viewStructure
    } = props;
    const ticketId = ticket.id;

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    // State
    const [ticketDetail, setTicketDetail] = useState({});
    const [ticketAffiliationProject, setTicketAffiliationProject] = useState('');
    const [titleDisplay, setTitleDisplay] = useState('');
    const [isDeletedCorporationOrigin, setIsDeletedCorporationOrigin] = useState(false);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    // const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isShowDialogDeleteTicketFromLiveChat, setIsShowDialogDeleteTicketFromLiveChat] = useState(false);
    const [projectDetails, setProjectDetails] = useState(projectInuseDetail);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const currentProjectId = localStorageUtil.getSelectedProjectId();
    const [isShowAffiliationProjectTypeTooltip, setIsShowAffiliationProjectTypeTooltip] = useState(false);
    const [isViewDelete, setIsViewDelete] = useState(false);
    const isAnonymousTicket = useMemo(() => {
        return (
            isHelpdeskListTicket &&
            (Utils.isAnonymousQAWaitingOrEndLiveChatTicket(ticketDetail) ||
                Utils.isAnonymousQAWaitingTicket(ticketDetail))
        );
    }, [isHelpdeskListTicket, ticketDetail]);

    useEffect(() => {
        const controller = new AbortController();
        setIsLoadingDetail(true);

        getDetailTicketInList(
            API,
            [{
                ticketId: ticket.id,
                affiliationOrganization: ticket?.affiliationOrganization
            }],
            ticketListType,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
        )
            .then(async ticketDetailListResponse => {
                if (Utils.isEmptyArray(ticketDetailListResponse)) {
                    updateAfterGetTicketDetailFail();
                    return;
                }

                let ticketDetailResponse = ticketDetailListResponse.find(ticketChild => ticketChild.id === ticketId);
                if (Utils.isEmptyObject(ticketDetailResponse)) {
                    updateAfterGetTicketDetailFail();
                    return;
                }

                // Ticket detail
                let ticketDetailFormatResponse = await getTicketStorageData(ticketDetailResponse);
                setTicketDetail(ticketDetailFormatResponse);

                // Set ticketAffiliationProject
                let ticketAffiliationProjectName = '';
                if (
                    isHelpdeskListTicket &&
                    (Utils.isAnonymousQAWaitingTicket(ticketDetailFormatResponse) || Utils.isAnonymousQARejectTicket(ticketDetailFormatResponse) || Utils.isAnonymousQATicketFromLiveChat(ticketDetailFormatResponse))
                ) {
                      ticketAffiliationProjectName = `${
                          ticketDetailFormatResponse.anonymousUserInfo?.lastName
                              ? ticketDetailFormatResponse.anonymousUserInfo?.lastName
                              : ''
                      } ${
                          ticketDetailFormatResponse.anonymousUserInfo?.firstName
                              ? ticketDetailFormatResponse.anonymousUserInfo?.firstName
                              : ''
                      }（未登録カスタマー）`;
                  } else if (ticketDetailFormatResponse?.affiliationProjectInfo?.name) {
                    ticketAffiliationProjectName =
                        ticketDetailFormatResponse?.affiliationProjectInfo?.name;
                        
                    if (isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff(projectInuseDetail, ticketDetailFormatResponse)) {
                        ticketAffiliationProjectName = getTicketAffiliationProjectName(ticketDetailFormatResponse);
                    }
                }
                if (ticketDetailFormatResponse.ticketType === Constant.TICKET_TYPE.TASK) {
                    if (ticketDetailFormatResponse?.creator && ticketDetailFormatResponse?.creatorInfo?.fullName) {
                        ticketAffiliationProjectName = `${ticketDetailFormatResponse?.creatorInfo?.fullName}`;
                    } else {
                        ticketAffiliationProjectName = '';
                    }
                }

                if (ticketDetailFormatResponse.ticketType === Constant.TICKET_TYPE.EMAIL) {
                    // Send from Sdesk
                    let toListOfEmailTicket = ticketDetailFormatResponse.toListOfEmailTicket;
                    if (toListOfEmailTicket) {
                        toListOfEmailTicket = Utils.convertJSONDataToObject(ticketDetailFormatResponse.toListOfEmailTicket);
                        if (!Utils.isEmptyArray(toListOfEmailTicket?.toList)) {
                            setIsShowAffiliationProjectTypeTooltip(true);
                            // Value display in ticket list
                            ticketAffiliationProjectName = `${toListOfEmailTicket?.firstTo} 、他`;
                            if (toListOfEmailTicket?.firstTo && toListOfEmailTicket?.firstTo.length > MAX_LENGTH_DISPLAY_TEXT) {
                                ticketAffiliationProjectName = `${toListOfEmailTicket?.firstTo.substring(0, MAX_LENGTH_DISPLAY_TEXT)}... 、他`;
                            }

                            // value in tooltip
                            let moreToList = toListOfEmailTicket?.toList.join('\n');
                            if (toListOfEmailTicket?.firstTo) {
                                moreToList = `${toListOfEmailTicket?.firstTo} \n ${moreToList}`
                            }
                            setTitleDisplay(moreToList);
                        } else {
                            ticketAffiliationProjectName = toListOfEmailTicket?.firstTo;
                        }
                    }
                }

                setTicketAffiliationProject(ticketAffiliationProjectName);

                // Set title
                // let ticketTitle = generateTicketTitle(ticketDetailFormatResponse);
                // if (ticketDetailFormatResponse.titleLineNumber === 2) {
                //     ticketTitle = getTitle(ticketDetailFormatResponse?.settingTitle);
                // }
                // let ticketTitle;
                // if (ticketDetailFormatResponse.titleLineNumber > 0) {
                //     ticketTitle = generateTicketTitle(ticketDetailFormatResponse);
                // } else {
                //     ticketTitle = generateTicketTitle(ticketDetailFormatResponse, 2);
                // }

                // setTitleDisplay(ticketTitle);

                // Set isDeletedCorporationOriginStatus
                let isDeletedCorporationOriginStatus = false;
                if (
                    ticketDetailFormatResponse.affiliationProjectInfo?.corporationInfo?.active ===
                    Constant.CORPORATION_ACTIVE.DELETED
                ) {
                    isDeletedCorporationOriginStatus = true;
                }
                setIsDeletedCorporationOrigin(isDeletedCorporationOriginStatus);
                setIsLoadingDetail(false);
            })
            .catch(error => {
                updateAfterGetTicketDetailFail();
                console.log('getDetailTicketInList error', error);
            });

            return () => {
                controller.abort();
                setProjectDetails({});
                setIsLoadingDetail(false);
                setTicketDetail({});
                setTicketAffiliationProject('');
                setIsDeletedCorporationOrigin(false);
            }
    }, [ticket.id, ticket.updatedAt, triggerSearch, props?.triggerReload]);

    const getTicketAffiliationProjectName = (ticketData) => {
        let anonymousUserInfo = ticketData.anonymousUserInfo;
        let userName = renderUserName(ticketData)
        return `${anonymousUserInfo.mailAddress} ${userName}`;        
    }

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };

    const openTicketDetailPanel = async () => {
        showLoadingMouse();
        let openDetailPanelProps = {
            API: API,
            panelId: panelId,
            tabId: tabId,
            ticketId: ticketId,
            componentName: componentName,
            ticketListType: ticketListType,
            panelType: panelType,
            history: history,
        }
        setIsLoading(true);
        let currentStatusTicket = await checkDetailTicket(API, ticketDetail.id);
        setIsLoading(false);

        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
            reloadTicketListByPanelType({
                panelType: getTicketListType()
                    ? getTicketListType()
                    : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            });
            hideLoadingMouse();
            return;
        }

        let newPanelTicketDetailId = Date.now().toString();
        let isTicketDeleted = Utils.isEmptyString(ticketDetail?.deletedAt) ? false : true;
        if (ticketListType.includes('helpdesk')) {
            let helpdeskTicketDetailPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
            );
            if (!Utils.isEmptyObject(helpdeskTicketDetailPanel)) {
                newPanelTicketDetailId = helpdeskTicketDetailPanel.id;
            }
        } else {
            let customerTicketDetailPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            );
            if (!Utils.isEmptyObject(customerTicketDetailPanel)) {
                newPanelTicketDetailId = customerTicketDetailPanel.id;
            }
        }
        setLastUserAction(LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW);

        const title = getTitle(ticketDetail.settingTitle);
        let isDraft = ticketDetail.public === Constant.TICKET_PUBLIC.DRAFT;
        let panelTicketType = ticketListType.includes('helpdesk') ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;

        // namnh_emailTicket
        addNewPanel({
            //update
            type: panelTicketType,
            tabId: ticketDetail.id,
            props: openDetailPanelProps,
            ticketId: ticketDetail.id,
            ticketOutline: title,
            isDraft: isDraft,
            isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL,
            isTicketDeleted: isTicketDeleted,
            newPanelId: newPanelTicketDetailId,
            // isOpenChat: true,
            startRelatePanelFromPanelId: openDetailPanelProps.panelId
        });


        // check open chat
        let viewFromProjectOfEscalateTicket = false;
        if (currentProjectId !== ticketDetail.projectOrigin 
            && currentProjectId !== ticketDetail.affiliationProject 
            && !ticketDetail.projectTarget.includes(currentProjectId) 
            && ticketDetail.ticketType !== Constant.TICKET_TYPE.TASK) {
                viewFromProjectOfEscalateTicket = true;
        }

        let arg = {
            detailTicket: ticketDetail,
            isAnonymousQAWaitingTicket: Utils.isAnonymousQAWaitingTicket(ticketDetail),
            viewFromProjectOfEscalateTicket: viewFromProjectOfEscalateTicket
        }

        let isOpenChat = isDisplayIconChat(arg);
        if (!isOpenChat) {
            hideLoadingMouse();
            return;
        }
        
        let chatThreadPanelType = ticketListType.includes('helpdesk') ?  Constant.PANEL_TYPE.HELPDESK_CHATTHREAD : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
        setTimeout(() => {
            let propsClone = {
                API: API,
                tabId: tabId,
                ticketId: ticketId,
                panelType: panelType,
            }

            addNewPanel({
                type: chatThreadPanelType,
                tabId: ticketDetail.id,
                currentPanelId: newPanelTicketDetailId,
                isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
                isShowAllChatPost: false,
                props: propsClone,
                ticketOutline: title,
                ticketId,
                openRelatePanelType: panelTicketType,
                isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL
            });


            setTimeout(() => {
                hideLoadingMouse();
            }, 2000);

        }, 2000);

    };

    const updateAfterGetTicketDetailFail = () => {
        setIsLoadingDetail(false);
        setTicketDetail({});
    }

    useEffect(() => {
        let ticketProperty = Constant.TICKET_PROPERTY.SENT;
        const structure = Utils.convertJSONDataToObject(viewStructure);
        if (!Utils.isEmptyObject(structure)) {
            ticketProperty = structure?.ticketProperty;
        }

        const isDeleteOrArchiveView = [Constant.TICKET_PROPERTY.DELETE].includes(ticketProperty);
        setIsViewDelete(isDeleteOrArchiveView);
    }, [viewStructure]);

    const isQAPanel = useMemo(() => {
        return [
            Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST,
            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        ].includes(panelType);
    }, [panelType]);

    if (Utils.isEmptyObject(ticketDetail) || isLoadingDetail) {
        return (<DetailTicketListSkeleton />)
    }

    const params = {
        panelList: panelList,
        setPanelList: setPanelList,
        triggerReload: setTriggerSearch,
        API: API,
        userDetail,
        setIsLoading,
        selectedTicket: ticketDetail,
        corporationId: corporationDetail.id,
        currentProjectId: projectInuseDetail?.id,
        setIsOpenModalReloadPage,
        projectDetails,
        corporationDetail
    }

    const renderButtonAnonymous = () => {
        if (ticketDetail.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
            return (<>
                {!ticketDetail.deletedAt && (<div className="approve-reject-anonymous">
                    <Button
                        variant="contained"
                        className="btn-hg20 btn-outline-primary approve-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            ticketDetail,
                            projectInuseDetail,
                            corporationDetail,
                            true
                        )}
                        onClick={e =>
                            onSubmitApproveAnonymousQaFromLiveChat(
                                params,
                                reloadTicketListByPanelType
                            )
                        }
                    >
                        {I18n.get('CBOTBT005')}
                    </Button>
                    <Button
                        variant="contained"
                        className="btn-hg20 btn-outline-light reject-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            ticketDetail,
                            projectInuseDetail,
                            corporationDetail,
                            false
                        )}
                        onClick={e =>
                            onClickRejectAnonymousQaTicket(
                                ticketDetail,
                                setSelectedTicket,
                                setIsConfirmRejectTicket
                            )
                        }
                    >
                        {I18n.get('USER04BTN055')}
                    </Button>
                </div>)}
            </>);
        }
        return (
            <div className="approve-reject-anonymous">
                <Button
                    variant="contained"
                    className="btn-hg20 btn-outline-primary approve-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(ticketDetail)}
                    onClick={e =>
                        onClickApproveAnonymousQaTicket(
                            ticketDetail,
                            setSelectedTicket,
                            setIsConfirmAcceptTicket
                        )
                    }
                >
                    {I18n.get('USER04BTN054')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-hg20 btn-outline-light reject-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(ticketDetail)}
                    onClick={e =>
                        onClickRejectAnonymousQaTicket(
                            ticketDetail,
                            setSelectedTicket,
                            setIsConfirmRejectTicket
                        )
                    }
                >
                    {I18n.get('USER04BTN055')}
                </Button>
            </div>
        );
    };

    const isShowLastMessage = () => {
        return (
            !Utils.isEmpty(ticketDetail.lastMessageInfo) &&
            ticketDetail.lastMessageInfo &&
            ticketDetail.lastMessageInfo.message &&
            ticketDetail.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.DRAFT
        );
    };

    const renderTicketAffiliationProject = () => {
        if (!isShowAffiliationProjectTypeTooltip) {
            return (
                <SDeskTooltip
                    value={`${ticketAffiliationProject}`}
                />
            )
        }

        return (
            <SDeskTooltip
                value={`${ticketAffiliationProject} `}
                toolTipValue={`${titleDisplay}`}
                tooltipAlign="left"
            />
        )
    }

    const isTicketTask = ticketDetail.ticketType === Constant.TICKET_TYPE.TASK;
    const isEmailTicket = ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL;

    return (
        <li
            id={`${ticketDetail?.id}-ticket-item-content`}
            key={`ticket-item-content-${ticketDetail?.id}`}
            data-cy="item-ticket-frame"
            className="ticket-item-frame"
        >
            <div className="ticket-item">
                <div className="ticket-head">
                    {isQAPanel ? (
                        <Typography variant="caption" display="block" className="ticket-sub">
                            {Utils.getDateTimeByFormatYYYYMMDDHHMM(ticketDetail.updatedAt)}
                        </Typography>
                    ) : (
                        <>
                            <div className="ticket-head-wrap">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketDetail}
                                    isShowEdit={true}
                                    isShowDefaultBookmark={false}
                                    panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                                />
                                <TaggedBookmarkListName
                                    bookmarkListText={ticketDetail?.bookmarkListText}
                                    className="tagged-bookmark-list-text"
                                />
                            </div>
                            <div className="bookmark-count">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketDetail}
                                    isShowEdit={false}
                                    isShowDefaultBookmark={true}
                                    tagDefaultBookmarkClassName="default-bookmark-ticket"
                                    panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                                />
                                <span className="bookmark-count-number">
                                    {ticketDetail.totalPrivateBookmark >= 100
                                        ? '99+'
                                        : ticketDetail.totalPrivateBookmark}
                                </span>
                            </div>
                        </>
                    )}
                    {/* <div className='ticket-star'>
                        <span className='item-star'><img src="/assets/image/icon-star.svg" alt="" /></span>
                        <span className='item-number'>12</span>
                    </div> */}
                </div>
                <div className="ticket-tlt-frame">
                    <div
                        className={
                            Utils.isAnonymousQAWaitingTicket(ticketDetail) ||
                            Utils.isAnonymousQARejectTicket(ticketDetail) ||
                            Utils.isAnonymousQATicketFromLiveChat(ticketDetail)
                                ? 'prj-icon no-bg'
                                : 'prj-icon'
                        }
                    >
                        {!isTicketTask &&
                            !isEmailTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            Utils.isEmpty(ticketDetail.affiliationProjectInfo) && (
                                <img
                                    src="/assets/image/project-icon.png"
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {!isTicketTask &&
                            !isEmailTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            !Utils.isEmpty(ticketDetail.affiliationProjectInfo) &&
                            ticketDetail.affiliationProjectInfo?.image !== '' && (
                                <img
                                    src={ticketDetail.affiliationProjectInfo?.image}
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {!isTicketTask &&
                            !isEmailTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            !Utils.isEmpty(ticketDetail.affiliationProjectInfo) &&
                            ticketDetail.affiliationProjectInfo?.image === '' && (
                                <>{ticketDetail.affiliationProjectInfo?.shortName}</>
                            )}

                        {/* AnonymousQA waiting or reject or from live chat*/}
                        {(Utils.isAnonymousQAWaitingTicket(ticketDetail) ||
                            Utils.isAnonymousQARejectTicket(ticketDetail) ||
                            Utils.isAnonymousQATicketFromLiveChat(ticketDetail)) && (
                            <img
                                src="/assets/image/anonymous-qa-avatar.svg"
                                alt="Anonymous avatar"
                            />
                        )}
                        {Utils.isAnonymousQAApproveTicket(ticketDetail) &&
                            ticketDetail.affiliationProjectInfo?.image !== '' && (
                                <img
                                    src={ticketDetail.affiliationProjectInfo?.image}
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {Utils.isAnonymousQAApproveTicket(ticketDetail) &&
                            ticketDetail.affiliationProjectInfo?.image === '' && (
                                <>{ticketDetail.affiliationProjectInfo?.shortName}</>
                            )}

                        {isTicketTask && (
                            <img src="/assets/image/icon-task-ticket.svg" alt="Ticket task" />
                        )}

                        {/* Email ticket send by desk */}
                        {isEmailTicket &&
                            ticketDetail.affiliationProject === ticketDetail.projectOrigin && (
                                <img
                                    src="/assets/image/icon-email-ticket-desk-send.svg"
                                    alt="Ticket email"
                                />
                            )}
                        {/* Email ticket send by customer */}
                        {isEmailTicket &&
                            ticketDetail.affiliationProject !== ticketDetail.projectOrigin && (
                                <img
                                    src="/assets/image/icon-email-ticket-desk-receive.svg"
                                    alt="Ticket email"
                                />
                            )}
                    </div>
                    <div className="ticket-info">
                        <div
                            className="ticket-info-left ticket-info-common"
                            onClick={event => openTicketDetailPanel()}
                        >
                            <SDeskTooltip
                                value={
                                    getTitle(ticketDetail?.settingTitle)
                                        ? generateDetatilTicketTitle(ticketDetail)
                                        : '[概要 (現在未記入)]'
                                }
                                className="titleDisplay"
                                isOverFlowTooltip={false}
                            />

                            {renderTicketAffiliationProject()}
                        </div>
                        <div className="ticket-info-right ticket-info-common">
                            {!Utils.isAnonymousQAWaitingOrEndLiveChatTicket(ticketDetail) &&
                                !Utils.isAnonymousQALiveChatDeleted(ticketDetail) && (
                                    <>
                                        <div className="unallocated custom-unallocated">
                                            <DetailTicketListStatus
                                                API={API}
                                                isHelpdeskListTicket={isHelpdeskListTicket}
                                                isCustomerListTicket={isCustomerListTicket}
                                                item={ticketDetail}
                                                selectedTicket={selectedTicket}
                                                setSelectedTicket={setSelectedTicket}
                                                setIsLoading={setIsLoading}
                                                userDetail={userDetail}
                                                setConfirmForceEditTicket={
                                                    setConfirmForceEditTicket
                                                }
                                                panelList={panelList}
                                                setPanelList={setPanelList}
                                                triggerReload={setTriggerSearch}
                                                isDeletedCorporationOrigin={
                                                    isDeletedCorporationOrigin
                                                }
                                                ticketListType={ticketListType}
                                                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                                                ticketList={ticketList}
                                                setTicketList={setTicketList}
                                                projectInuseDetail={projectInuseDetail}
                                                corporationDetail={corporationDetail}
                                            />
                                        </div>

                                        {/* Assignee */}
                                        {isQAPanel ? (
                                            <DetailTicketListAssignee
                                                {...props}
                                                API={API}
                                                isHelpdeskListTicket={isHelpdeskListTicket}
                                                isCustomerListTicket={isCustomerListTicket}
                                                ticket={ticketDetail}
                                                ticketListType={ticketListType}
                                                userDetail={userDetail}
                                                selectedTicket={selectedTicket}
                                                setSelectedTicket={setSelectedTicket}
                                                projectUserList={projectUserList}
                                                setIsLoading={setIsLoading}
                                                setConfirmForceEditTicket={
                                                    setConfirmForceEditTicket
                                                }
                                                panelList={panelList}
                                                setPanelList={setPanelList}
                                                triggerReload={setTriggerSearch}
                                                isDeletedCorporationOrigin={
                                                    isDeletedCorporationOrigin
                                                }
                                                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                                                corporationDetail={corporationDetail}
                                                projectInuseDetail={projectInuseDetail}
                                            />
                                        ) : (
                                            <div className="ticket-date-assignee-wrap">
                                                {!isAnonymousTicket && (
                                                    <Typography
                                                        variant="caption"
                                                        display="block"
                                                        className="ticket-sub"
                                                    >
                                                        更新日：
                                                        {Utils.getDateTimeByFormatYYYYMMDDHHMM(
                                                            ticketDetail.updatedAt
                                                        )}
                                                    </Typography>
                                                )}
                                                <DetailTicketListAssignee
                                                    {...props}
                                                    API={API}
                                                    isHelpdeskListTicket={isHelpdeskListTicket}
                                                    isCustomerListTicket={isCustomerListTicket}
                                                    ticket={ticketDetail}
                                                    ticketListType={ticketListType}
                                                    userDetail={userDetail}
                                                    selectedTicket={selectedTicket}
                                                    setSelectedTicket={setSelectedTicket}
                                                    projectUserList={projectUserList}
                                                    setIsLoading={setIsLoading}
                                                    setConfirmForceEditTicket={
                                                        setConfirmForceEditTicket
                                                    }
                                                    panelList={panelList}
                                                    setPanelList={setPanelList}
                                                    triggerReload={setTriggerSearch}
                                                    isDeletedCorporationOrigin={
                                                        isDeletedCorporationOrigin
                                                    }
                                                    setIsOpenModalReloadPage={
                                                        setIsOpenModalReloadPage
                                                    }
                                                    corporationDetail={corporationDetail}
                                                    projectInuseDetail={projectInuseDetail}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}

                            {isAnonymousTicket && renderButtonAnonymous()}
                            {isAnonymousTicket && !isQAPanel && (
                                <Typography
                                    variant="caption"
                                    display="block"
                                    className="ticket-sub"
                                >
                                    更新日：
                                    {Utils.getDateTimeByFormatYYYYMMDDHHMM(ticketDetail.updatedAt)}
                                </Typography>
                            )}
                        </div>
                    </div>
                </div>

                {isShowLastMessage() && (
                    <DetailTicketListLastMessage
                        ticket={ticketDetail}
                        API={API}
                        setIsLoading={setIsLoading}
                        panelId={panelId}
                        getTicketListType={getTicketListType}
                        ticketListType={ticketListType}
                    />
                )}

                {!Utils.isEmptyArray(ticketDetail.attachment) &&
                    !ticketDetail?.isHideAttachment && (
                        <DetailTicketListThumbnail
                            ticket={ticketDetail}
                            setIsShowPopupLogout={setIsShowPopupLogout}
                        />
                    )}
            </div>
            <ConfirmDialog
                isOpen={isShowDialogDeleteTicketFromLiveChat}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST')}
                closeCallBack={() => setIsShowDialogDeleteTicketFromLiveChat(false)}
                okCallBack={() =>
                    handleDeleteCompleteTicketLiveChat(
                        API,
                        setIsLoading,
                        ticketDetail,
                        enqueueSnackbar,
                        setCorporationDetail,
                        closePanelTab,
                        corporationDetail,
                        panelId,
                        ticketListType,
                        panelType,
                        tabId,
                        setTriggerSearch,
                        panelList,
                        setIsShowDialogDeleteTicketFromLiveChat,
                        reloadTicketListByPanelType,
                        setIsOpenModalReloadPage,
                        projectInuseDetail?.id,
                        projectDetails
                    )
                }
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={
                    <div>
                        <span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span>
                        <br />
                        <span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span>
                    </div>
                }
                textSubmit={I18n.get('CM-BUTTON-OK')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
        </li>
    );
}
